import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly memoryStorage = new Map<string, string>();

  getItem(key: string): string | null {
    const storage = this.getSessionStorage();

    if (storage) {
      const value = storage.getItem(key);
      if (value !== null) {
        return value;
      }
    }

    return this.memoryStorage.get(key) ?? null;
  }

  setItem(key: string, value: string): void {
    const storage = this.getSessionStorage();

    if (storage) {
      try {
        storage.setItem(key, value);
      } catch (error) {
        console.warn(
          `Falha ao salvar a chave "${key}" no sessionStorage. Usando fallback em memoria.`,
          error
        );
      }
    }

    this.memoryStorage.set(key, value);
  }

  removeItem(key: string): void {
    const storage = this.getSessionStorage();

    if (storage) {
      try {
        storage.removeItem(key);
      } catch (error) {
        console.warn(`Falha ao remover a chave "${key}" do sessionStorage.`, error);
      }
    }

    this.memoryStorage.delete(key);
  }

  private getSessionStorage(): Storage | null {
    try {
      if (typeof sessionStorage === 'undefined') {
        return null;
      }

      return sessionStorage;
    } catch (error) {
      console.warn('sessionStorage indisponivel neste navegador/contexto.', error);
      return null;
    }
  }
}
